import React from 'react';
import AboutUsImageSrc from '../../assets/about-us.jpg';
import { AboutUsContainer, AboutUsRow, AboutUsImageCol, AboutUsContentCol, AboutUsImage, Subtitle, SectionTitle, StoryText, CardGrid, InfoCard, IconCircle, CardTitle, CardDescription, Image } from './AboutUs.styled';
import HalalImage from '../../assets/halal.png';
import FsscImage from '../../assets/fssc.png';

const AboutUs = () => {
  return (
    <AboutUsContainer fluid id="about">
      <AboutUsRow>
        <SectionTitle>Tentang Kami</SectionTitle>
        <Subtitle>Solusi Kemasan Plastik Terpercaya Sejak 1999</Subtitle>
      </AboutUsRow>
      <AboutUsRow>
        <AboutUsImageCol md={6}>
          <AboutUsImage src={AboutUsImageSrc} alt="Water Filtration Plant" />
        </AboutUsImageCol>
        <AboutUsContentCol md={6}>
          <StoryText>Sejak 1999, kami telah menjadi mitra terpercaya dalam menyediakan <strong>kemasan plastik berkualitas tinggi</strong> untuk industri makanan dan minuman di Indonesia. Produk utama kami adalah <strong>cup berbahan PP food-grade</strong> yang aman dan andal.</StoryText>
          <StoryText>Pada tahun 2009, kami berinovasi dengan menyediakan layanan <strong>printing/cetakan berwarna</strong> untuk membantu produk Anda tampil lebih menarik dan informatif. </StoryText>
          <StoryText>Kami terus berkomitmen untuk berinovasi dan meningkatkan kualitas, memastikan kami selalu menjadi solusi kemasan terbaik bagi Anda.</StoryText>
          <CardGrid>
            <InfoCard>
              <IconCircle><Image src={HalalImage} alt="Halal" /></IconCircle>
              <CardTitle>Bersertifikasi Halal</CardTitle>
            </InfoCard>
            <InfoCard>
              <IconCircle><Image src={FsscImage} alt="FSSC 2000" /></IconCircle>
              <CardTitle>Bersertifikasi ISO 22000</CardTitle>
            </InfoCard>
          </CardGrid>
        </AboutUsContentCol>
      </AboutUsRow>
    </AboutUsContainer>
  );
};

export default AboutUs;
